<template>
  <div v-loading="loading" class="myNotice" element-loading-text="数据获取中">
    <div class="top">
      <div class="topTitle">
        <el-radio-group v-model="radio" size="small" @change="changeRadio">
          <el-radio-button label="项目公告">
            项目公告
            <el-badge v-if="prjNum>0" :value="prjNum" :max="99" class="item"></el-badge>
          </el-radio-button>
          <el-radio-button label="系统公告">
            系统公告
            <el-badge v-if="enterpriseNum>0" :value="enterpriseNum" :max="99" class="item"></el-badge>
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="queryArea">
        <el-form ref="form" :model="selectForm" inline class="formStyle" size="small">
          <el-form-item label="标题:">
            <el-input v-model="selectForm.keyWord" placeholder="请输入标题" size="small">
            </el-input>
          </el-form-item>
          <el-form-item v-if="radio=='项目公告'" label="所属项目:">
            <el-select v-model="selectForm.prjId" size="small" placeholder="请选择" filterable>
              <el-option v-for="(item,index) in prjList" :key="index" :label="item.prjName" :value="item.prjId" />
            </el-select>
          </el-form-item>
          <el-form-item label="日期:">
            <el-date-picker v-model="selectForm.time" style="width: 100%" size="small" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="fetchData(1)">查询</el-button>
            <el-button size="small" type="primary" plain @click="resetBtn">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="listArea">
      <notice-list :notice-data-list="noticeDataList" :look-notice="look" :fetch-data="fetchData"
        :name="name" :type="type" :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
      </notice-list>
    </div>
    <!-- 查看 -->
    <notice-look :dialog-look-title="dialogLookTitle" :announdialog-look-visible="AnnoundialogLookVisible"
      :table-row="tableRow" :close="closeLook" :name="name"></notice-look>
  </div>
</template>

<script>
import prjNoticeService from "@/CommonDP/service/prjNotice-service";
import sysNoticeService from "@/CommonDP/service/sysNotice-service";
import { mapState } from "vuex";
import requestprj from "@/CommonDP/service/integratedModel-service";
import noticeList from "@/CommonDP/components/notice/noticeList";
import noticeLook from "@/CommonDP/components/notice/noticeLook";
export default {
  name: "MyNotice",
  components: {
    noticeList,
    noticeLook
  },
  data() {
    return {
      selectForm: {
        keyWord: "",
        prjId: "",
        time: []
      },
      levelDic: [
        {
          name: "启用",
          id: 1
        },
        {
          name: "禁用",
          id: 2
        },
        {
          name: "草稿",
          id: 0
        }
      ],
      noticeDataList: [],
      page: {
        totalCount: 0,
        pageNum: 1,
        pageSize: 20
      },
      loading: false,
      tableRow: {},
      AnnoundialogLookVisible: false,
      prjNum: 0,
      enterpriseNum: 0,
      radio: "项目公告",
      prjList: [],
      dialogLookTitle: "查看",
      name: "prj",
      type: "work"
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.queryNoticeList();
    this.queryPrjList();
    this.queryNum();
  },
  methods: {
    async queryPrjList() {
      this.prjList = [];
      const params = {
        keyword: "",
        enterpriseId: this.enterpriseId
      };
      const res = await requestprj.queryPrj(params);
      const all = [
        {
          prjId: "",
          prjName: "全部"
        }
      ];
      this.prjList = all.concat(res.data);
    },
    async queryNum() {
      const res = await prjNoticeService.prjNoticeGetNoticeNum(this.enterpriseId, this.selectForm.prjId);
      this.prjNum = res.data.prjNum;
      this.enterpriseNum = res.data.enterpriseNum;
    },
    fetchData(val) {
      this.page.pageNum = val;
      this.noticeDataList = [];
      this.queryNoticeList();
    },
    resetBtn() {
      this.selectForm.keyWord = "";
      this.selectForm.prjId = "";
      this.selectForm.time = [];
      this.page.pageNum = 1;
      this.noticeDataList = [];
      this.queryNoticeList();
    },
    queryNoticeList() {
      this.loading = true;
      if (this.radio === "项目公告") {
        this.queryNum();
        this.queryPrjNoticeList();
      } else {
        this.querySysNoticeList();
      }
    },
    async queryPrjNoticeList() {
      const params = {
        endTime: null,
        startTime: null,
        enterpriseId: this.enterpriseId,
        keyWord: this.selectForm.keyWord,
        prjId: this.selectForm.prjId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        isPublish: 1
      };
      if (this.selectForm.time.length) {
        params.endTime = this.selectForm.time[1] + " " + "23:59:59";
        params.startTime = this.selectForm.time[0] + " " + "00:00:00";
      }
      try {
        const res = await prjNoticeService.prjNoticeList(params);
        this.noticeDataList = res.data;
        this.page.totalCount = res.totalCount;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async querySysNoticeList() {
      const params = {
        endTime: null,
        startTime: null,
        enterpriseId: this.enterpriseId,
        keyWord: this.selectForm.keyWord,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        isPublish: 1
      };
      if (this.selectForm.time.length) {
        params.endTime = this.selectForm.time[1] + " " + "23:59:59";
        params.startTime = this.selectForm.time[0] + " " + "00:00:00";
      }
      try {
        const res = await sysNoticeService.sysNoticeList(params);
        this.noticeDataList = res.data;
        this.page.totalCount = res.totalCount;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async look(row) {
      this.$set(row, "isRead", 1);
      this.tableRow = {};
      if (this.radio === "项目公告") {
        this.name = "prj";
        const res = await prjNoticeService.prjNoticeGet(row.noticeId);
        this.tableRow = res.data;
      } else {
        this.name = "work";
        const res2 = await sysNoticeService.sysNoticeGet(row.noticeId);
        this.tableRow = res2.data;
      }
      this.tableRow.userNames = this.tableRow.userList.map((ele) => ele.name).join(",");
      const data = new FormData();
      data.append("noticeId", row.noticeId);
      await prjNoticeService.noticeReadRecordAdd(data);
      this.queryNum();
      this.AnnoundialogLookVisible = true;
    },
    changeRadio() {
      if (this.radio === "项目公告") {
        this.name = "prj";
      } else {
        this.name = "work";
      }
      this.resetBtn();
    },
    closeLook() {
      this.AnnoundialogLookVisible = false;
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.queryNoticeList();
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.queryNoticeList();
    }
  }
};
</script>

<style lang="scss" scoped>
.myNotice {
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    background: #fff;
    .topTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #e5e8f1;
      padding: var(--middle-space) var(--big-space);
      /deep/.el-badge {
        right: -14px;
        top: -8px;
        z-index: 99;
        position: absolute;
        .el-badge__content {
          line-height: 15px;
        }
      }
    }
    .queryArea {
      padding: var(--middle-space) var(--big-space);
      .formStyle {
        .el-form-item {
          margin-bottom: 0 !important;
        }
      }
    }
  }

  .listArea{
    width: 100%;
    height: 1px;
    flex-grow: 1;
  }
}
</style>
